import {DiffStats} from '@github-ui/diffs/DiffStats'
import {useDiffstatData} from '../page-data/loaders/use-diffstat-data'
import {useIsDataRouterEnabled} from '@github-ui/react-core/future/use-is-data-router-enabled'
import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {pullRequestsLayoutRoute} from '../routes/layout-route'

export function DiffStat() {
  const isDataRouter = useIsDataRouterEnabled()

  if (isDataRouter) {
    return <DataRouterDiffStat />
  }

  return <NavigatorDiffStat />
}

// Deprecated and removable once we remove when cleaning up PR non data router code.
function NavigatorDiffStat() {
  const {
    data: {diffstat},
  } = useDiffstatData()

  return (
    <DiffStats
      linesAdded={diffstat.linesAdded}
      linesDeleted={diffstat.linesDeleted}
      linesChanged={diffstat.linesChanged}
    />
  )
}

function DataRouterDiffStat() {
  const {data} = useRouteQuery(pullRequestsLayoutRoute, 'diffstat')

  if (!data || !data.diffstat) {
    return null
  }

  const {diffstat} = data

  return (
    <DiffStats
      linesAdded={diffstat.linesAdded}
      linesDeleted={diffstat.linesDeleted}
      linesChanged={diffstat.linesChanged}
    />
  )
}

try{ DiffStat.displayName ||= 'DiffStat' } catch {}
try{ NavigatorDiffStat.displayName ||= 'NavigatorDiffStat' } catch {}
try{ DataRouterDiffStat.displayName ||= 'DataRouterDiffStat' } catch {}